module.exports = __webpack_public_path__ + "../resources/img/icon-info.7ed8ec19.svg";